<template>
  <div :class="['content mb-5', { 'policy-no-subtitle': !pageMeta.subTitle }]">
    <t-sub-nav
      class="mb-5"
      :loading="loading"
      :items="
        $secondaryNav.customerPolicyNavItems(
          $route.params.id,
          hasVirtualLocation(selectedCustomerPolicy)
        )
      "
    />
    <b-row>
      <b-col>
        <h2 class="mb-3">{{ this.$t("Locations using this policy") }}</h2>
        <t-data-table
          data-test-id="policies-sites-data-table"
          disable-row-select
          with-filter
          hoverable
          :filter-placeholder="$t('Search Locations')"
          :loading="loading"
          :table-data="dataSet"
          :actions="tableActions"
          :server-items-length="serverItemsLength"
          @on-add="onAdd"
          @on-export="onExport"
          @on-row-clicked="onRowClicked"
          :searchExports="searchExports"
          @export-headers="exportedHeaders"
          @async-paginate="onSearch"
        />
      </b-col>
    </b-row>
  </div>
</template>

<route>
{
  "name": "Customer Locations",
  "meta": {
    "authorize" : [1, 3, 4]
  }
}
</route>
<script>
import { mapMutations, mapActions, mapGetters } from "vuex";
import policySubPages from "@/mixins/policySubPages";

export default {
  layout: "customer",
  mixins: [policySubPages],
  data: function () {
    return {
      loading: true,
      currentHeaders: null,
      serverItemsLength: 0,
      dataOptions: {
        results: 10,
        page: 1,
        sortBy: "name",
        sortDesc: "asc",
        filter: null,
      },
      tableActions: {
        add: {
          enabled: false,
        },
        import: { enabled: false },
        export: { enabled: true },
        delete: { enabled: true },
      },
      searchExports: ["name", "type"],
      dataSet: {
        fields: [
          { value: "name", text: this.$t("Location Name"), sortable: true },
          { value: "ip", text: this.$t("IP Address"), sortable: true },
          { value: "type", text: this.$t("Type"), sortable: true },
          { value: "id", text: this.$t("Location ID"), sortable: true },
        ],
        items: [],
      },
    };
  },
  watch: {
    locations: {
      handler() {
        this.dataSet.items = this.locations.all.data.map((location) => {
          return {
            ...location,
            isSelectable: location.deletable,
          };
        });
      },
      deep: true,
      immediate: true,
    },
    serverTotal: {
      handler() {
        this.serverItemsLength = this.serverTotal;
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations("modal", ["createModal", "showModal"]),
    ...mapActions("customerPolicies", ["fetchCustomerPolicy"]),
    ...mapActions("locations", ["fetchLocations"]),
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
    onAdd({ name, modal, type }) {
      this.createModal({
        modal,
        title: this.$t("Add Site"),
        dataTestId: `modal-add-site-${type}`,
        subtitle: name,
        modalData: {
          type,
          customerPolicies: this.customerPolicies,
        },
        props: {
          size: "lg",
          okTitle: this.$t("Save"),
        },
      });

      this.showModal();
    },
    onImport(items) {
      console.log("Import items:", items); // eslint-disable-line no-console
    },
    exportedHeaders(headers) {
      this.currentHeaders = headers;
    },
    onExport(items) {
      if (items.length) {
        const exportData = items.map((res) => {
          let payload = {};
          this.currentHeaders.forEach((headers) => {
            return (payload[headers.value] = res[headers.value]);
          });

          return payload;
        });
        this.$downloadCSV(exportData, "Locations");
      } else {
        this.displayToast({
          title: this.$t("Failure"),
          message: this.$t("No Locations in table"),
          duration: 2000,
          variant: "danger",
        });
      }
    },
    onRowClicked(item) {
      this.$router.push({
        path: `/customer/environment/locations/${item.id}?type=${item.type}`,
      });
    },
    async onSearch(options) {
      if (options.itemsPerPage === undefined) return;
      if (options.itemsPerPage) {
        this.dataOptions.results = options.itemsPerPage;
      }
      if (options.page) {
        this.dataOptions.page = options.page;
      }
      if (options.sortBy) {
        this.dataOptions.sortBy = options.sortBy[0];
      }
      if (options.sortDesc) {
        this.dataOptions.sortDesc = options.sortDesc;
      }

      if (this.dataOptions.filter !== options.filter) {
        this.dataOptions.page = 1;
      }
      this.dataOptions.filter = options.filter;

      try {
        await this.fetchLocations({
          id: this.selectedUser.id,
          policyId: this.$route.params.id,
          type: "all",
          ...this.dataOptions,
        });
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    ...mapGetters("customerPolicies", ["selectedCustomerPolicy"]),
    ...mapGetters("locations", ["locations", "serverTotal"]),
    ...mapGetters("authentication", ["selectedUser"]),
    ...mapGetters("pageMeta", ["pageMeta"]),
  },
  async created() {
    this.setPageTitle(this.selectedCustomerPolicy.name);
    this.setPageSubtitle([this.selectedCustomerPolicy.description]);
    this.loading = false;
  },
};
</script>
